import * as Sentry from '@sentry/react'
import { createBrowserHistory } from 'history'

const currentErrors = [
  'Request failed with status code',
  '400',
  '422',
  'timeout',
  "Failed to execute 'insertBefore' on 'Node'",
  "Failed to execute 'removeChild' on 'Node'",
  'recaptcha',
]

const regexErrors = new RegExp(currentErrors.join('|'), 'mi')

const SENTRY_DSN = import.meta.env.VITE_APP_SENTRY_DSN
const isProduction = import.meta.env.VITE_APP_ENV_NAME === 'PROD'
const history = createBrowserHistory()

const initializeSentry = () => {
  if (!isProduction) return

  Sentry.init({
    dsn: SENTRY_DSN,
    integrations: [
      Sentry.replayIntegration({
        maskAllText: false,
      }),
      Sentry.browserTracingIntegration(),
      Sentry.reactRouterV5BrowserTracingIntegration({
        history,
      }),
    ],
    ignoreErrors: [regexErrors],
    beforeSend(event) {
      if (event.exception && event.exception.values) {
        for (const error of event.exception.values) {
          if (
            error.type === 'TypeError' &&
            error.stacktrace &&
            error.stacktrace.frames
          ) {
            for (const frame of error.stacktrace.frames) {
              if (frame.filename && frame.filename.includes('recaptcha')) {
                return null
              }
            }
          }
        }
      }
      return event
    },
    // Performance Monitoring
    tracesSampleRate: 0.1, //  Capture 10% of the transactions
    // Session Replay
    replaysSessionSampleRate: 0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 0.1, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  })
}

initializeSentry()
